import { Component, OnInit } from '@angular/core';
import { AwsService } from 'src/app/services/awsser/aws.service';
import swal2 from 'sweetalert2';
import { PagosService } from '../../../services/pagos/pagos.service';
import { Router } from '@angular/router';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { FacturasService } from 'src/app/services/service.index';
import { Subscription } from 'rxjs';
import { MantContEmit } from '../../../services/service.index';
@Component({
  selector: 'app-expedienteaf',
  templateUrl: './expedienteaf.component.html',
  styleUrls: ['./expedienteaf.component.css']
})
export class ExpedienteAfComponent implements OnInit {
  idu: string;
  contributor_id = '';
  filesToUpload: any[] = [];
  private subscription: Subscription;
  constructor(
              private aws: AwsService,
              private pagosService: PagosService,
              private router: Router,
              private usuarioService: UsuarioService,
              private facturasService: FacturasService,
              private eventService: MantContEmit) { }

  ngOnInit() {
    this.subscription = this.eventService.expedienteafEmitter.subscribe((data: {idc: number}) => {
      this.obtenerInfoContributor(data.idc);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  obtenerInfoContributor(cont_id){
    this.contributor_id = cont_id
    this.aws.getContributorDocuments(this.contributor_id).subscribe(resp => {
      this.filesToUpload = resp.data.filter((item: { attributes: { status: string; }; }) => item.attributes.status === 'PI' || item.attributes.status === 'IN').map((item: { attributes: any; }) => item.attributes);
    })
  }

  // eventos para el control y vista para los archivos a subir //
dragEnter(event: DragEvent, id: string, item: any) {
  event.preventDefault();
  event.stopPropagation();

  if (item.status === 'IN') {
    return;
  }

  const el = document.getElementById(id);
  if (el) {
    el.style.border = 'dashed 2px blue';
  }
}

dragLeave(event: DragEvent, id: string) {
  event.preventDefault();
  event.stopPropagation();

  const el = document.getElementById(id);
  if (el) {
    el.style.border = 'dashed 1px #979797';
  }
}

drop(event: DragEvent, id: string, item: any) {
  event.preventDefault();
  event.stopPropagation();

  const el = document.getElementById(id);
  if (el) {
    el.style.border = 'dashed 1px #979797';
  }
  if (item.status === 'IN') {
    return;
  }
  const files = event.dataTransfer && event.dataTransfer.files;
  if (files && files.length > 0) {
    this.fileBrowseHandler(files, null, item);
  }
}

  // async fileBrowseHandler( e: any, nombre, doc: string, format_type ) {
  async fileBrowseHandler( e: any, s, doc) {
      if (!e || !e[0]) {
        return;
      }
      const extension = e[0].name.split('.').pop().toLowerCase();

      if (extension !== 'pdf') {
        swal2.fire('Atención', 'Solo se permiten archivos PDF', 'info');
        s.value = '';
        return;
      }
    doc.loading = true;
    const resul = await this.callupload(e[0], doc);
    if (!resul.status) {
      swal2.fire('Atención', 'Hubo un problema al subir el archivo, favor de intentar de nuevo', 'info');
      doc.loading = false;
      return;
    }
    this.aws.patchUrl(this.contributor_id, doc.id, resul.resp.url).subscribe(res => {
        doc.status = 'IN';
        doc.url = resul.resp.url;
        doc.loading = false;
    }, (() => {
      this.facturasService.borraFacturaBucket(resul.resp.url).subscribe(() => {
      swal2.fire('Atención', 'Hubo un problema al subir el archivo, favor de intentar de nuevo', 'info');
      doc.loading = false;
      });
    }))
  }

  async callupload(file, doc){
    try {
      // const r = await this.aws.uploadFile(file, idu)
      const r = await this.facturasService.uploadFileSB(file, file.name)
      let resp = {
        status: true,
        resp: r,
        msg: 'Archivo subido correctamente'
      }
      return resp
    } catch (error) {
      console.log('error', error);
      let resp = {
        status: false,
        resp: error,
        msg: 'Fallo al subir archivo'
      }
      return resp
    }
  }

borradocatta(doc) {
  doc.deleting = true;
  setTimeout(() => {
    this.aws.patchUrlreemplazo(doc.contributor_id, doc.id).subscribe(() => {
      this.facturasService.borraFacturaBucket(doc.url).subscribe(() => {
        doc.status = 'PI';
        doc.url = null;
        doc.deleting = false;

      });
    });
  }, 400); // mismo tiempo que la animacion
}

get todosSubidos(): boolean {

  if (!this.filesToUpload || this.filesToUpload.length === 0) {
    return false;
  }
  for (let i = 0; i < this.filesToUpload.length; i++) {
    const doc = this.filesToUpload[i];
    //obligatorio
    if (doc.mandatory === 'SI' && doc.status !== 'IN') {
      return false;
    }
  }
  //todos los obligatorios están subidos
  return true;
}

descargar(url: string) {
  const a = document.createElement('a');
  a.href = url;
  a.download = '';
  a.target = '_blank';
  a.click();
}

}
